import styled from 'styled-components';
import { donedealBreakpoints } from 'styled-system';

const Wrapper = styled.div`
  min-width: 0;
`;

const PriceContainer = styled.div<{ isGrid?: boolean }>`
  display: flex;
  flex-direction: column;
`;

const PriceRow = styled.div<{ isGrid?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  column-gap: ${({ theme }) => theme.donedeal.spacing.S8};
`;

const Price = styled.div<{ isValidPrice?: boolean; isGrid?: boolean }>`
  ${({ theme, isValidPrice, isGrid }) => {
    if (isValidPrice && !isGrid) return theme.donedeal.fontSize.H24;
    if (!isValidPrice && isGrid) return theme.donedeal.fontSize.M14;
    return theme.donedeal.fontSize.L18;
  }};

  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};

  ${donedealBreakpoints.media.medium} {
    margin-bottom: 0;
    ${({ theme, isValidPrice, isGrid }) => {
      if (isValidPrice) return theme.donedeal.fontSize.H24;
      if (isGrid) return theme.donedeal.fontSize.M16;
      return theme.donedeal.fontSize.L18;
    }};
  }
`;

const PricePerMonth = styled.div<{ isGrid?: boolean }>`
  ${({ theme }) => theme.donedeal.fontSize.M14};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};
  align-content: flex-end;
  display: ${({ isGrid }) => (isGrid ? 'none' : 'block')};
  margin-bottom: ${({ theme }) => theme.donedeal.spacing.S2};
  overflow: hidden;
  text-overflow: ellipsis;

  ${donedealBreakpoints.media.large} {
    display: block;
  }
`;

const OldPrice = styled.span`
  ${({ theme }) => theme.donedeal.fontSize.M14};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARK};
  font-weight: ${({ theme }) => theme.donedeal.fontWeight.regular};
  position: relative;
  display: inline-block;

  &:after {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: inherit;
    transform: rotate(-12.2deg);
  }
`;

export { Wrapper, Price, PricePerMonth, PriceContainer, PriceRow, OldPrice };
